// Deep-link target for the schedule card on Settings -> Configuration, e.g. from the
// financial-condition modal and the case page.
export const INVOICE_AUTO_GENERATION_SCHEDULE_SECTION_ID = 'invoice-auto-generation-schedule';

// Which invoice autogeneration schedule setting applies depends on the invoicing interval class:
// date-based intervals use the tenant-wide interval date, week-based intervals the interval weekday.
// Mirrors the backend scheduling semantics (DailyInvoiceGenerationService) — new interval
// codes need a backend scheduling decision before they can appear here.
export const DATE_BASED_INVOICING_INTERVALS = ['MONTHLY', 'EVERY_2_MONTHS', 'QUARTERLY', 'HALF_YEARLY', 'ANNUALLY'];
export const WEEK_BASED_INVOICING_INTERVALS = ['WEEKLY', 'BIWEEKLY'];

export type InvoiceScheduleKind = 'date' | 'weekday' | null;

export const getInvoiceScheduleKind = (invoicingIntervalCode: string | null | undefined): InvoiceScheduleKind => {
    if (invoicingIntervalCode && DATE_BASED_INVOICING_INTERVALS.includes(invoicingIntervalCode)) return 'date';
    if (invoicingIntervalCode && WEEK_BASED_INVOICING_INTERVALS.includes(invoicingIntervalCode)) return 'weekday';
    return null;
};

export const ordinal = (day: number): string => {
    const mod10 = day % 10;
    const mod100 = day % 100;
    if (mod10 === 1 && mod100 !== 11) return `${day}st`;
    if (mod10 === 2 && mod100 !== 12) return `${day}nd`;
    if (mod10 === 3 && mod100 !== 13) return `${day}rd`;
    return `${day}th`;
};
